import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Sprawling 5.60-acre land parcel in prime Andheri West",
    "Four 37-storey towers with skyline and amenity views",
    "Zero back-facing units — every home with a premium view",
  ];
  const highlights2 = [
    "4-level basement parking (no stack) + 2 spots per 3BHK",
    "Vastu-aligned east-west facing apartment layouts",
    "Grand Arrival Experience - 150m landscaped driveway",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {/* {project} */}
        DLF Andheri, The West Park -{" "}
        <span className="d-inline-block">
          DLF Brings Its Vision to the West
        </span>
      </h1>

      <p className="overview-para">
        DLF, India’s most iconic name in luxury real estate, is now redefining
        the skyline of Mumbai with its first-ever landmark project in Andheri
        West. Nestled at the vibrant junction of Link Road and JVLR Extension,
        this 5.60-acre sanctuary is a masterstroke of design, access, and
        refined living. The initial launch includes four architecturally
        sculpted towers rising 37 storeys, offering just 416 handpicked
        residences curated for a life less ordinary. With vastu-aligned layouts,
        panoramic city and amenity-facing views, and a lush 150-meter landscaped
        driveway as your gateway — every corner speaks of intentional luxury.
        From rooftop lounges to A++ amenities and seamless 4-level basement
        parking, this isn’t just a residence, it’s a signature.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
